//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'

export default {
  name: 'AppHeaderBag',

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  methods: mapActions('cart', ['remove'])
}
